export default "__VITE_ASSET__BtFJPEuV__"